import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import Nav from './Nav';

const useStyle = makeStyles((theme) => ({
  main: {
    padding: "30px",
  },
  cards: {
    display: "flex",

    flexWrap: "wrap",
    justifyContent: "space-evenly",
    cursor: "pointer",
  },

  container: {
    boxShadow: " 0 15px 20px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      boxShadow: " 0 5px 15px rgba(0, 0, 0, 0.2)",
    },
    padding: "15px",
    width: "250px",
    margin: "20px",
  },
  image: {
    height: "150px",
    width: "220px",
  },
  datelogo: {
    paddingTop: "18px",
    height: "40px",
    width: "20px",
  },
  datecontainer: {
    display: "flex",
  },
  newsTitle: {
    color: "hsl(205,78%,33%)",
  },
}));

const News = () => {
  const classes = useStyle();
  return (
    <div className={classes.main}>
      <Nav></Nav>
      <div>
        <Typography
          variant="h5"
          style={{
            color: "hsl(205,78%,33%)",
            display: "flex",
            justifyContent: "center",
            margin: "2% 0",
          }}
        >
          News
        </Typography>

        <p
          style={{
            marginTop: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          MOT members are actively engaged in different activities, This page
          shows the different events, activities, and news related to MOT
          operation
        </p>
      </div>
      <div className={classes.cards}>
        <div className={classes.container}>
          <img
            src="/motNews.jpg"
            alt="img"
            className={classes.image}
          />
          <div className={classes.datecontainer}>
            <img
              src="https://img.icons8.com/small/32/000000/date-span.png"
              alt="date"
              className={classes.datelogo}
            />
            <p style={{ paddingTop: "15px" }}> 22 Aug 2022</p>
          </div>
          <div className={classes.newsTitle}>
            <b style={{ fontWeight: "20rem" }}><a href="https://www.facebook.com/missionoxygenteam/">Training for 5 days in which we provide training on one day general training and two-two days on ICU Equipment, OT Equipment, and their safety measures. </a></b>
          </div>
        </div>

        <div className={classes.container}>
          <img
            src="/motnews.png"
            alt="img"
            className={classes.image}
          />
          <div className={classes.datecontainer}>
            <img
              src="https://img.icons8.com/small/32/000000/date-span.png"
              alt="date"
              className={classes.datelogo}
            />
            <p style={{ paddingTop: "15px" }}> 12 Aug 2022</p>
          </div>
          <div className={classes.newsTitle}>
            <b style={{ fontWeight: "20rem" }}><a href="https://www.facebook.com/missionoxygenteam/">Thankyou Mission Oxygen Team MOT for summoning me for my short views regarding the current state of Biomedical Instrumentation and Deep Learning in Nepal.</a></b>
          </div>
        </div>

        <div className={classes.container}>
          <img
            src="/motnews2.png"
            alt="img"
            className={classes.image}
          />
          <div className={classes.datecontainer}>
            <img
              src="https://img.icons8.com/small/32/000000/date-span.png"
              alt="date"
              className={classes.datelogo}
            />
            <p style={{ paddingTop: "15px" }}> 25 Aug 2022</p>
          </div>
          <div className={classes.newsTitle}>
            <b style={{ fontWeight: "20rem" }}><a href="ttps://www.facebook.com/missionoxygenteam/">Being chairperson of Strengthening Healthcare System Through Trained Biomedical Engineer at Butwal, debdaha medical college, province 5
Supported by UNDP, Accelerator Lab
Organized by MOT, joint project of BSN And RAN</a></b>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default News;
